if (document.querySelector('.block-calculator')) {
  function calculate() {
    const price = parseFloat(document.getElementById('price').value) || 0;
    const interest = parseFloat(document.getElementById('interest').value) || 0;
    const period = parseInt(document.getElementById('period').value) || 0;
    const down = parseFloat(document.getElementById('downPayment').value) || 0;
    const clearBtn = document.getElementById('clearBtn');
    const downloadBtn = document.getElementById('downloadPDF');

    document.querySelector('.invalid-form-note').classList.remove('active');

    if (price <= 0 || period <= 0) {
      document.getElementById('monthlyPayment').innerText = '—';
      document.getElementById('totalInterest').innerText = '—';
      document.getElementById('fullPayment').innerText = '—';
      Object.assign(clearBtn.style, {
        opacity: '0',
        visibility: 'hidden',
      });
      return;
    }

    const principal = price - down;
    const monthlyRate = interest / 100 / 12;

    let monthlyPayment;
    if (monthlyRate > 0) {
      monthlyPayment =
        (principal * (monthlyRate * Math.pow(1 + monthlyRate, period))) /
        (Math.pow(1 + monthlyRate, period) - 1);
    } else {
      monthlyPayment = principal / period;
    }

    const totalPayment = monthlyPayment * period;
    const totalInterest = totalPayment - principal;

    document.getElementById('fullPayment').innerText = `$${totalPayment.toFixed(
      2
    )}`;
    document.getElementById(
      'totalInterest'
    ).innerText = `$${totalInterest.toFixed(2)}`;
    document.getElementById(
      'monthlyPayment'
    ).innerText = `$${monthlyPayment.toFixed(2)}`;
    Object.assign(clearBtn.style, {
      opacity: '1',
      visibility: 'visible',
    });
  }
  document.querySelectorAll('.calculator-form input').forEach((input) => {
    input.addEventListener('change', calculate);
  });

  document.getElementById('clearBtn').addEventListener('click', () => {
    document
      .querySelectorAll('.calculator-form input')
      .forEach((input) => (input.value = ''));
    document.getElementById('monthlyPayment').innerText = '0';
    document.getElementById('totalInterest').innerText = '0';
    document.getElementById('fullPayment').innerText = '0';
    document.querySelector('.invalid-form-note').classList.remove('active');
    Object.assign(clearBtn.style, {
      opacity: '0',
      visibility: 'hidden',
    });
  });

  $('#downloadBtn').on('click', function () {
    var $form = $('#prime-calculator');

    if (
      !$form.find('input[name="price"]').val() ||
      !$form.find('input[name="interest"]').val() ||
      !$form.find('input[name="period"]').val()
    ) {
      document.querySelector('.invalid-form-note').classList.add('active');
      return;
    } else {
      document.querySelector('.prime-loader').classList.add('active');
    }
    var data_content = {
      price: $form.find('input[name="price"]').val(),
      interest: $form.find('input[name="interest"]').val(),
      period: $form.find('input[name="period"]').val(),
      down: $form.find('input[name="downPayment"]').val(),
      totalInterest: $('#totalInterest').html(),
      monthly: $('#monthlyPayment').html(),
      full: $('#fullPayment').html(),
    };

    // AJAX
    $.post(
      prime_ajaxur,
      {
        action: 'prime_loan_pdf',
        data_content: data_content,
      },
      function (response) {
        if (response.success) {
          document.querySelector('.prime-loader').classList.remove('active');
          var link = document.createElement('a');
          link.href = 'data:application/pdf;base64,' + response.data;
          link.download = 'the_prime_trailers_loan.pdf';
          link.click();
        } else {
          alert('Error PDF: ' + response.data);
        }
      }
    );
  });
}
